export default "__VITE_ASSET__dc758e55__"